export function drawerTopicKey(topic) {
  if (!topic) return "";
  return `${topic.id}-${topic.label}`;
}

export function isDrawerTopicIsolated(tagEditEnabled, clickedTopicKey) {
  return Boolean(tagEditEnabled && clickedTopicKey);
}

export function visibleDrawerTopicTags(
  topicTags,
  tagEditEnabled,
  clickedTopicKey,
) {
  const tags = Array.isArray(topicTags) ? topicTags : [];
  if (!isDrawerTopicIsolated(tagEditEnabled, clickedTopicKey)) {
    return tags;
  }
  return tags.filter((topic) => drawerTopicKey(topic) === clickedTopicKey);
}

export function shouldRenderIsolatedTopicDropdowns(
  tagEditEnabled,
  topicIsolated,
) {
  return Boolean(tagEditEnabled && topicIsolated);
}

export function nextClickedTopicKey(currentKey, topic) {
  const key = drawerTopicKey(topic);
  return currentKey === key ? null : key;
}

export function nextDrawerTopicOverride(overrides, topic, field, option) {
  if (!option?.value || !topic) return overrides || {};
  const current = (overrides && overrides[topic.id]) || {};
  return {
    ...(overrides || {}),
    [topic.id]: {
      sentiment:
        field === "sentiment"
          ? option.value
          : current.sentiment ?? topic.sentiment,
      intent: field === "intent" ? option.value : current.intent ?? topic.intent,
    },
  };
}

export function hasPendingDrawerTopicEdits(overrides) {
  return Boolean(overrides && Object.keys(overrides).length > 0);
}
